<template>
    <div class="pa-2" v-if="mail">
        <div class="v-flex mr-3 mt-3 ml-12">
            <p-inc-toolbar-button
                icon    = "mdi-file-document-outline"
                :label  = "$t('mail.templates.label')"
                :height = "900"
                ref     = "templateMenu"
            >
                <template v-slot:content>
                    <p-inc-template-list
                        :index    = "mail.index"
                        :step     = "mail.step"
                        @template = "onTemplate"
                    />
                </template>
            </p-inc-toolbar-button>

            <p-inc-toolbar-button
                icon    = "mdi-attachment"
                :label  = "$t('mail.attachments.label')"
                :height = "900"
            >
                <template v-slot:content="{ open }">
                    <p-inc-attachments
                        :incident           = "incident"
                        :step               = "step"
                        :open               = "open"
                        :selected-documents = "selectedDocs"
                        @selected           = "onSelected"
                    />
                </template>
            </p-inc-toolbar-button>

            <p-inc-toolbar-button
                icon    = "mdi-clipboard-file-outline"
                :label  = "$t('mail.assessment.label')"
                :height = "900"
            >
                <template v-slot:content>
                    <p-inc-unit-documents
                        :unit               = "unit"
                        :units              = "units"
                        type                = "ASSESSMENT"
                        :selected-documents = "selectedDocs"
                        @selected           = "onSelected"
                    />
                </template>
            </p-inc-toolbar-button>

            <p-inc-toolbar-button
                icon    = "mdi-file-cog-outline"
                :label  = "$t('mail.maintenance.label')"
                :height = "900"
            >
                <template v-slot:content>
                    <p-inc-unit-documents
                        :unit               = "unit"
                        :units              = "units"
                        type                = "MAINTENANCE"
                        :selected-documents = "selectedDocs"
                        @selected           = "onSelected"
                    />
                </template>
            </p-inc-toolbar-button>

            <v-btn
                class  = "dialog-button"
                color  = "primary"
                @click = "onSend"
                depressed
                style="height: 40px!important; margin-top: -6px;"
            >
                <div style="display: block">
                    <div>
                        <v-icon color="white" size="22">mdi-email-outline</v-icon>
                    </div>
                    <div class="white--text button-label">{{ $t('mail.send') }}</div>
                </div>
            </v-btn>
        </div>

        <div class="ma-2 mb-1" >
            <div class="white pa-3 pt-2 pb-6">
                <v-row class="no-frame">
                    <p-inc-mail-recipient
                        v-model     = "data.to"
                        :label      = "$t('mail.to')"
                        :recipients = "mail.to"
                        chip-color  = "primary"
                    />
                </v-row>
                <v-row class="no-frame mt-1">
                    <p-inc-mail-recipient
                        v-model     = "data.cc"
                        :label      = "$t('mail.cc')"
                        :recipients = "mail.cc"
                    />
                </v-row>
                <v-row class="no-frame mt-1">
                    <v-text-field
                        v-model = "data.subject"
                        class   = "mail-adress"
                        hide-details
                    >
                        <template v-slot:prepend-inner>
                            <div class = "mail-label  mr-2">
                                {{ $t('mail.subject') }}
                            </div>
                        </template>
                    </v-text-field>
                </v-row>
            </div>

        </div>

        <div class="white pa-4 pb-0" style="height: 470px">
            <vue-editor
                v-model         = "data.content"
                :editor-toolbar = "customToolbar"
                style="min-height: 400px; max-height: 400px; height: 400px;"
            />
        </div>

        <div class="pl-4 mail-attachments">
            <div class="mail-attachment-list" :key = "refresh" >
                <div v-for="(document, index) in selectedDocs" :key = "index" style="width: calc(50% - 4px); margin-bottom: 3px;">
                    <p-inc-selectable-document
                        class="background-aliceblue"
                        :document = "document"
                        :selected = "isSelected(document)"
                        @selected = "onSelected"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { VueEditor, Quill }   from "vue2-editor";
import Core                   from "@/modules/core/service/Core";
import Inb                    from "@/modules/inb/service/Inb";
import Inc                    from "@/modules/inc/service/Inc";
import Mail                   from "@/modules/inc/mail/service/Mail";
import PIncMailRecipient      from "@/modules/inc/mail/private/PIncMailRecipient.vue";
import Template               from "@/modules/msd/templates/service/Template";
import PIncToolbarButton      from "@/modules/inc/mail/private/PIncToolbarButton.vue";
import PIncUnitDocuments      from "@/modules/inc/mail/private/PIncUnitDocuments.vue";
import PIncAttachments        from "@/modules/inc/mail/private/PIncAttachments.vue";
import PIncTemplateList       from "@/modules/inc/mail/private/PIncTemplateList.vue";
import PIncSelectableDocument from "@/modules/inc/mail/private/PIncSelectableDocument.vue";

const icons = Quill.import('ui/icons');
icons['bold'  ] = '<i class="mdi mdi-format-bold edit-icon"></i>';
icons['italic'] = '<i class="mdi mdi-format-italic edit-icon"></i>';
icons['underline'] = '<i class="mdi mdi-format-underline edit-icon"></i>';
icons['image'] = '<i class="mdi mdi-image-outline"></i>';
icons['list'] = {
    bullet : '<i class="mdi mdi-format-list-bulleted edit-icon"></i>',
    check  : '<i class="mdi mdi-format-list-checkbox edit-icon"></i>',
    ordered: '<i class="mdi mdi-format-list-numbered edit-icon"></i>',
}

const Size = Quill.import('attributors/style/size');
Size.whitelist = ['10px', '12px', '14px', '16px'];
Quill.register(Size, true);


export default {
    name: "CIncMailEditor",

    components: {
        PIncSelectableDocument,
        PIncTemplateList,
        PIncAttachments,
        PIncUnitDocuments,
        PIncToolbarButton,
        PIncMailRecipient,
        VueEditor
    },

    props: {
        mail: {
            required: false,
            type    : Object,
        },

        incident: {

        },

        unit: {

        },

        units: {

        },

        step: {

        }
    },

    data: () => ({
        templateMenu : false,
        templates    : null,
        template     : null,
        selectedDocs : [],
        refresh      : 0,
        subject      : null,
        customToolbar: [
            [
                { header: [1, 2, 3, 4, false] }
            ],
            [   { size: Size.whitelist }
            ],
            [
                "bold",
                "italic",
                "underline"
            ],
            [
                { list: "ordered" },
                { list: "bullet" }
            ],
            [
                "image"
            ],
        ],
        data: {
            to     : [],
            cc     : [],
            subject: "",
            content: "",
        }
    }),

    mounted() {
        this.initialize();
    },

    watch: {
        mail () {
            this.initialize();
        },


    },

    methods: {
        /**
         * Initializes the mail editor for the given mail content. During initialization, the possible recipients are
         * determined and, if necessary, the mail content is resolved based on the given tag name.
         */
        initialize () {
            if (!this.mail) {
                return;
            }

            this.data.subject = "";
            this.data.content = "";
            this.selected     = [];
            this.selectedDocs = [];
            this.data.to      = this.mail.selected.to;
            this.data.cc      = this.mail.selected.cc;

            Template.loadTemplates(this.unit.customer.id, true, (data) => {
                this.templates = data;
            });

            if (this.mail.template) {
                Mail.resolve (this.mail.template, this.mail.index, this.mail.step, this.unit, this.incident, (data) => {
                    this.data.subject = data.subject;
                    this.data.content = data.content;
                });
            }

            if (this.mail.attachments) {
                this.mail.attachments.forEach (d => {
                    this.selectedDocs.push (d);
                })
            }

            this.refresh ++;
        },

        /**
         * Executed when a template has been selected by the user. The subject and the content of the mail are replaced
         * with the given resolved template.
         *
         * @param template the resolved template
         */
        onTemplate (template) {
            this.data.subject = template.subject;
            this.data.content = template.content;
            this.templateMenu = false;
            this.$refs.templateMenu.close();
        },

        /**
         * Executed when a document is selected or deselected.
         *
         * @param event the event contains the document and the info whether the document was selected or deselected.
         */
        onSelected (event) {
            const index = this.selectedDocs.findIndex(d => d.id === event.document.id);
            if (event.selected) {
                if (index < 0) {
                    this.selectedDocs.push(event.document);
                }

            } else {
                if (index >= 0) {
                    this.selectedDocs.splice(index, 1);
                }
            }

            console.log(this.selectedDocs)
            this.refresh ++;
        },

        onSend () {
            if (this.data.to.length === 0) {
                Core.message.popup(this, "mail.message.to.empty");
                return;
            }

            if (!this.isValidEmail(this.data.to)) {
                Core.message.popup(this, "mail.message.to.notvalid");
                return;
            }

            if (!this.isValidEmail(this.data.cc)) {
                Core.message.popup(this, "mail.message.cc.notvalid");
                return;
            }

            const to = this.addressList(this.data.to);
            const cc = this.addressList(this.data.cc);

            Core.loading(this, true, "Email wird gesendet ...");
            const attachments = this.selectedDocs.map (d => d.id);

            Mail.sendMail(
                this,
                this.mail.incident,
                this.mail.bidId,
                this.unit.id,
                this.mail.step,
                to,
                cc,
                this.data.subject,
                this.data.content,
                attachments, () => {
                    this.show = false;
                    Inc.refresh(this)
                    this.$bus.$emit(Inb.event.refresh);
                    this.$emit("input", false);

                    if (this.mail.callback) {
                        this.mail.callback ();
                    }

                    Core.loading(this, false);
                    this.$emit("sended")
                }, (error) => {
                    console.log("**** error " )
                    Core.message.popup(this, error.id)
                    Core.loading(this, false);
                });
        },

        isValidEmail (receiverList) {
            let valid = true;
            receiverList.forEach(receiver => {
                receiver.emails.forEach(email => {
                    if (!email.valid) {
                        valid = false;
                    }
                });
            });

            return valid;
        },

        isSelected (document) {
            if (!this.selectedDocs) {
                return false;
            }

            return !!this.selectedDocs.find(d => d.id === document.id);
        },

        addressList (receiverList) {
            console.log("addressList", receiverList)
            const list = [];
            receiverList.forEach(receiver => {
                receiver.emails.forEach(email => {
                    if (email.valid && email.selected) {
                        list.push (email.address);
                    }
                });
            });

            return list;
        }
    }
}
</script>

<style lang="scss" scoped>

.mail-label {
    padding-top: 9px;
    background-color: white;
    height: 36px;
    width: 70px;
    border-radius: 2px!important;
    font-size: 15px;
}

.mail-adress {
    padding-top: 0;
}

::v-deep .ql-editor {
    min-height: 250px;
}

.doc-area {
    margin-left: -5px;
    overflow-x: scroll;
}

.mail-attachments {
    max-height: 216px;
    overflow-y: scroll;
    overflow-x: hidden
}

.mail-attachment-list {
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    margin-top: 7px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 1px;
    width: calc(100% + 0px);
}

.doc-area::-webkit-scrollbar {
    width: 7px !important;
    height: 8px;
}

.button-label {
    font-size: 12px;
}

::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
    content: 'Kleine Schrift';
    font-size: 10px !important;
}

::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
    content: 'Normal';
    font-size: 12px !important;
}

::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
    content: 'Mittel';
    font-size: 14px !important;
}

::v-deep .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
    content: 'Gross';
    font-size: 16px !important;
}

::v-deep .ql-editor {
    font-size: 12px!important;
    color: black;
    zoom: 1.3;
    letter-spacing: 0.0em;
}

::v-deep .v-text-field.v-text-field--solo .v-input__control {
    min-height: 35px;
    padding: 0;
    border-style: solid;
    border-color: lightgray;
}

::v-deep .v-btn:not(.v-btn--round).v-size--default {
    height: 36px;
    min-width: 48px;
    padding: 0!important;
}

</style>

